import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
// import { STEP_NAMES } from "../../../utils/funnel/steps.desktop";

const LeadProgress = ({
    tabs,
    currentStepIndex,
    currentTabIndex,
    stepNames,
    onTabClick
}) => {
    const getClass = (index) => {
        const isVisited = index <= currentStepIndex;
        const isCurrent = index === currentTabIndex;
        //eslint-disable-next-line
        const className = `dots ${isVisited ? "visited" : ""} ${isCurrent ? "active" : ""}`;
        return className;
    };

    return (
        <div className="mb-5" styleName={"styles.dotsArea"}>
            {
                tabs && tabs.map(tab =>
                    (<span
                        key={tab.index}
                        styleName={getClass(tab.index)}
                        onClick={() => onTabClick(stepNames[tab.name])}
                    />)
                )
            }
        </div>
    );
};

LeadProgress.propTypes = {
    tabs: PropTypes.array.isRequired,
    currentStepIndex: PropTypes.number.isRequired,
    currentTabIndex: PropTypes.number.isRequired,
    onTabClick: PropTypes.func.isRequired,
    stepNames: PropTypes.object
};

export default LeadProgress;
